module.exports = __webpack_public_path__ + "static/img/xiantiao.8739b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/element/xiantiao.png
// module id = q3hJ
// module chunks = 6